module.exports = __webpack_public_path__ + "static/media/hog@3x.d00890a6.jpg";